import React from 'react';
import { AgTechVerticalPopUpMenu, AgTechVerticalPopUpMenuSection } from '@agtech/web/components/Menus/AgTechVerticalPopUpMenu';
import RoleManagementDialog from './RoleManagementDialog';

export type TeamMemberActionMenuProps = {
    userId: number,
    userName: string,
    roleIds: number[]
}

const TeamMemberActionMenu = (props: TeamMemberActionMenuProps) => {
    return (
        <AgTechVerticalPopUpMenu>
            <AgTechVerticalPopUpMenuSection header="Team Member">
                <RoleManagementDialog.Button userId={props.userId} userName={props.userName} roleIds={props.roleIds} />
            </AgTechVerticalPopUpMenuSection>
        </AgTechVerticalPopUpMenu>
    )
};

export default TeamMemberActionMenu;
